import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown-navigator"
export default class extends Controller {
  navigate(event) {
    const selection = event.target.selectedOptions[0]

    if (selection && selection.dataset.url) {
      if (window.Turbo) {
        window.Turbo.visit(selection.dataset.url);
      } else {
        window.location = selection.dataset.url;
      }
    }
  }
}
